<template>
  <a-modal v-model:visible="reasonVisible" width="400px" title="收集信息" centered>
    <div class="content">
      <div class="item title">患者未复诊原因收集</div>
      <!-- {{ prop.info }} -->
      <a-checkbox-group
        class="item"
        v-model:value="unRevisitReason"
        name="checkboxgroup"
        :options="reasonList"
      />
      <a-textarea v-model:value="unRevisitSupplement" :maxlength="100" placeholder="补充说明" />
    </div>
    <template #footer>
      <a-button type="primary" @click="saveThenFinish">提交并完成</a-button>
    </template>
  </a-modal>
</template>

<script setup>
import { defineExpose, ref, defineProps, defineEmits } from 'vue'
import { apiGetAllUnRevisitReason, apiSubmitReason } from '@/api/workPlace/retreatment.js'
import { message } from 'ant-design-vue'

const prop = defineProps({
  info: {
    type: Object,
    default: () => {}
  }
})
const reasonVisible = ref(false)
const reasonList = ref([])
const initModal = () => {
  reasonVisible.value = true
  apiGetAllUnRevisitReason().then(res => {
    reasonList.value = res.map(item => {
      return {
        label: item.desc,
        value: item.value
      }
    })
  })
}

const unRevisitReason = ref([])
const unRevisitSupplement = ref('')
const emits = defineEmits(['completeBuss'])
const saveThenFinish = () => {
  if (!unRevisitReason.value.length) {
    return message.warning('请至少选择一项！')
  }
  if (unRevisitReason.value.includes(10) && !unRevisitSupplement.value.trim()) {
    return message.warning('请输入补充说明！')
  }
  // HACK:调整业务类型 22 特殊处理
  const is = [22].includes(prop.info.businessType)
  const reserveId = is ? prop.info.businessId : prop.info.quickDealNavigationBusinessId
  apiSubmitReason({
    reserveId: reserveId,
    unRevisitReason: unRevisitReason.value.join(','),
    unRevisitSupplement: unRevisitSupplement.value
  }).then(() => {
    emits('completeBuss')
  })
}
defineExpose({
  initModal
})
</script>
<style lang="scss" scoped>
.content {
  width: 100%;
  .title {
    font-size: 16px;
    font-weight: 500;
  }
  .item {
    margin-bottom: 20px;
  }
}
</style>
